import React from 'react';
import { FaExclamationTriangle, FaHistory } from 'react-icons/fa';
import { formatarDataHoraRascunho } from './rascunhoOrcamentoPolicy';
import '../../css/financeiro-parcela-pagar.css';

// Rascunho não salvo (08/10/2026): ao abrir o orçamento, oferece restaurar o que ficou sem Salvar.
// Sem X e sem fechar pelo fundo: o operador precisa escolher (Descartar ou Restaurar).
export default function ModalRascunhoOrcamento({ pendente, onRestaurar, onDescartar }) {
    if (!pendente) return null;
    const quando = formatarDataHoraRascunho(pendente.salvo_em);
    return (
        <div className="modal fade show d-block fin-pp fin-pp__modalbg" role="dialog" aria-modal="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content fin-pp__modal">
                    <div className="fin-pp__modal-head">
                        <span className="fin-pp__modal-head-ic"><FaHistory size={17} /></span>
                        <h3 className="fin-pp__modal-title">Alterações não salvas
                            <span className="fin-pp__modal-sub">
                                {quando ? `Rascunho guardado em ${quando}` : 'Há um rascunho guardado deste orçamento'}
                            </span>
                        </h3>
                    </div>
                    <div className="modal-body">
                        <p style={{ margin: 0, color: 'var(--fin-tx)', fontSize: 14, lineHeight: 1.5 }}>
                            Você saiu desta tela sem salvar. As alterações ficaram guardadas como rascunho.
                            Restaurar coloca o rascunho na tela — ele só passa a valer depois de <strong>Salvar</strong>.
                        </p>
                        {pendente.desatualizado && (
                            <div
                                style={{
                                    display: 'flex', gap: 10, alignItems: 'flex-start', marginTop: 14,
                                    padding: '12px 15px', borderRadius: 'var(--fin-rds)', fontSize: 13, lineHeight: 1.5,
                                    background: 'var(--fin-dgb)', border: '1px solid #f3c7c9', color: 'var(--fin-dg)',
                                }}
                            >
                                <FaExclamationTriangle size={15} style={{ flex: 'none', marginTop: 2 }} />
                                <span>
                                    Este orçamento foi salvo depois que o rascunho começou. Se restaurar e salvar,
                                    as alterações gravadas depois do rascunho serão substituídas.
                                </span>
                            </div>
                        )}
                    </div>
                    <div className="fin-pp__modal-foot">
                        <button type="button" className="fin-pp__btn fin-pp__btn--danger-ghost" onClick={onDescartar}>
                            Descartar rascunho
                        </button>
                        <button type="button" className="fin-pp__btn fin-pp__btn--primary" onClick={onRestaurar}>
                            Restaurar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
